import { useEffect } from "react";
import "./header.css";
import { Link } from "react-router-dom";

const Header = () => {
  useEffect(() => {
    const menuToggle = document.getElementById("menuToggle");
    const mobileContainer = document.getElementById("mobileMenuContainer");
    const closeMenuBtn = document.getElementById("closeMenuBtn");
    const overlayClose = document.getElementById("overlayClose");
    const mobileLinks = document.querySelectorAll(".mobile-link");
    const openMenu = () => {
      mobileContainer.classList.add("active");
      document.body.classList.add("menu-open");
    };
    const closeMenu = () => {
      mobileContainer.classList.remove("active");
      document.body.classList.remove("menu-open");
    };
    if (menuToggle) menuToggle.addEventListener("click", openMenu);
    if (closeMenuBtn) closeMenuBtn.addEventListener("click", closeMenu);
    if (overlayClose) overlayClose.addEventListener("click", closeMenu);
    mobileLinks.forEach((link) => link.addEventListener("click", closeMenu));
    const header = document.getElementById("mainHeader");
    const handleScroll = () => {
      if (window.scrollY > 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="container">
          <div className="top-left">
            <span>
              <i className="fa-solid fa-phone"></i> +1 (212) 555 1278
            </span>
            <span>
              <i className="fa-solid fa-envelope"></i> hello@ask-jeevesip.com
            </span>
            <span>
              <i className="fa-solid fa-clock"></i> 24/7 support
            </span>
          </div>

          <div className="top-center">
            <div className="marquee">
              <i className="fa-regular fa-star"></i> SMS • WhatsApp • Voice • AI
              Marketing • Patented Tech
              <i className="fa-regular fa-star"></i> TCPA Compliant • O'Hanlon
              Patents • Enterprise Grade
            </div>
          </div>

          <div className="top-right">
            <a href="#">
              <i className="fa-brands fa-facebook-f"></i>
            </a>
            <a href="#">
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="#">
              <i className="fa-brands fa-youtube"></i>
            </a>
            <a href="#">
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a href="#">
              <i className="fa-brands fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      {/* HEADER */}
      <header id="mainHeader">
        <div className="nav">
          <div className="logo">
            Ask Jeeves <span>IP</span>
          </div>
          {/* Desktop Navigation */}
          <ul className="desktop-menu">
            <li>
              <Link to={"/"}>
                <i className="fas fa-home"></i> Home
              </Link>
            </li>

            <li className="has-dropdown">
              <Link to={"/about"}>
                <i className="fas fa-info-circle"></i> About
              </Link>

              <ul className="dropdown">
                <li>
                  <Link to={"/leadership"}>Leadership</Link>
                </li>
                <li>
                  <Link to={"/history"}>History</Link>
                </li>
                <li>
                  <Link to={"/case"}>Case Studies</Link>
                </li>
                <li>
                  <Link to={"/faqs"}>FAQs</Link>
                </li>
                <li>
                  <Link to={"/terms"}>Terms & Conditions</Link>
                </li>
                <li>
                  <Link to={"/privacy"}>Privacy Policy</Link>
                </li>
                <li>
                  <Link to={"/marketing"}>Marketing Policy</Link>
                </li>
                <li>
                  <Link to={"/eula"}>EULA</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to={"/services"}>
                <i className="fas fa-cogs"></i> Services
              </Link>
            </li>

            <li>
              <Link to={"/press"}>
                <i className="fas fa-newspaper"></i> Press
              </Link>
            </li>

            <li>
              <Link to={"/patents"}>
                <i className="fas fa-file-alt"></i> Patents
              </Link>
            </li>

            <li>
              <Link to={"/sms"}>
                <i className="fas fa-comment-sms"></i> SMS
              </Link>
            </li>

            <li>
              <Link to={"/feature"}>
                <i className="fas fa-star"></i> Features
              </Link>
            </li>

            <li>
              <Link to={"/blog"}>
                <i className="fas fa-blog"></i> Blog
              </Link>
            </li>

            <li>
              <Link to={"/contact"}>
                <i className="fas fa-envelope"></i> Contact
              </Link>
            </li>
          </ul>

          {/* Desktop CTA */}
          <div className="cta-container">
            <Link to={"/contact"} className="cta">
              <i className="fa-solid fa-rocket"></i>
              <span>Get Started</span>
            </Link>
          </div>

          {/* Mobile Menu Toggle Button */}
          <button
            className="menu-toggle"
            id="menuToggle"
            aria-label="Toggle menu"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div className="mobile-menu-container" id="mobileMenuContainer">
        <div className="mobile-menu-overlay-close" id="overlayClose"></div>

        <div className="mobile-menu">
          <div className="mobile-menu-header">
            <span className="logo-small">
              Ask Jeeves <span>IP</span>
            </span>

            <button
              className="close-menu"
              id="closeMenuBtn"
              aria-label="Close menu"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          <ul>
            <li>
              <Link to={"/"} className="mobile-link">
                <i className="fas fa-home"></i> Home
              </Link>
            </li>

            <li>
              <Link to={"/about"} className="mobile-link">
                <i className="fas fa-info-circle"></i> About
              </Link>
            </li>

            <li>
              <Link to={"/services"} className="mobile-link">
                <i className="fas fa-cogs"></i> Services
              </Link>
            </li>

            <li>
              <Link to={"/press"} className="mobile-link">
                <i className="fas fa-newspaper"></i> Press
              </Link>
            </li>

            <li>
              <Link to={"/patents"} className="mobile-link">
                <i className="fas fa-file-alt"></i> Patents
              </Link>
            </li>

            <li>
              <Link to={"/sms"} className="mobile-link">
                <i className="fas fa-comment-sms"></i> SMS
              </Link>
            </li>

            <li>
              <Link to={"/feature"} className="mobile-link">
                <i className="fas fa-star"></i> Features
              </Link>
            </li>

            <li>
              <Link to={"/blog"} className="mobile-link">
                <i className="fas fa-blog"></i> Blog
              </Link>
            </li>

            <li>
              <Link to={"/contact"} className="mobile-link">
                <i className="fas fa-envelope"></i> Contact
              </Link>
            </li>
          </ul>

          <div className="mobile-cta-btn">
            <a href="#" className="cta">
              <i className="fa-solid fa-rocket"></i>
              <span>Get Started</span>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
